<template>
    <v-app id="inspire">
        <v-layout row justify-center>
            <v-dialog v-model="onShow" persistent max-width="45%">
                <v-card>
                    <v-card-title>
                        <span class="subheading">MARS - MAC-Pool: congatec - Reservation Response</span>

                    </v-card-title>

                    <v-divider></v-divider>
                    
                    <v-container grid-list-xs style="margin-top: -20px">
                        <v-layout wrap>

                            <v-flex class="modal-flex-height" xs12>
                                <v-subheader class="body-2 reservation-failed" style="text-align: left">
                                    Reservation for MAC-Pool {{ macPool.name }}
                                    (ID: {{macPool.poolId}}, OUI: {{ macPool.oui}}) FAILED!
                                </v-subheader>
                            </v-flex>

                            <v-flex class="modal-flex-height" xs12>
                                <v-subheader class="body-2 reservation-failed" style="text-align: left">
                                    {{message}}
                                </v-subheader>
                            </v-flex>


                            <v-flex class="modal-flex-height" xs12>
                                <v-subheader class="body-2 reservation-failed" style="text-align: left">
                                    {{additionalMessage}}
                                </v-subheader>
                            </v-flex>
                        </v-layout>
                    </v-container>


                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn id="finish_reservation_failed_button" class="text-none" small @click="close">Ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-app>
</template>

<script>
    import {EventBus} from "../../../eventbus";

    export default {
        name: 'MacPoolReservationFailedModal',

        props: {
            value: Boolean,

            responseStatus: Number,

            responseData: {
                pool: {
                    poolId: Number,
                    oui: Number,
                    name: String,
                    startMac: String,
                    endMac: String,
                    nextMac: String,
                    available: Number,
                    availableInPercent: Number,
                    capacity: Number,
                    isActive: Boolean,
                    macsPerRequest: Number,
                    macsPerUserDay: Number
                },
                requestedMacs: Number,
                reservedMacs: Number,
                firstReservedMac: String,
                lastReservedMac: String,
                remainingMacPerUserDay: Number,
            },

            macPool: {
                poolId: Number,
                oui: Number,
                name: String,
                startMac: String,
                endMac: String,
                nextMac: String,
                available: Number,
                availableInPercent: Number,
                capacity: Number,
                isActive: Boolean,
                macsPerReq: Number,
                macsPerUserDay: Number
            },
        },

        computed: {
            onShow: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            },

            message: {
                get() {
                    if (this.responseStatus === 409) {
                        return "Reservation failed. Pool is locked currently.";
                    } else if (this.responseData == null || this.responseData === "") {
                        return "The maximum number of reservations for MAC pool " + this.macPool.name + " per request has been exceeded.";
                    } else if (this.responseData && this.responseData.remainingMacPerUserDay) {
                        return "The maximum number of reservations for MAC pool " + this.macPool.name
                            + " has been exceeded.";
                    } else if (this.responseData && this.responseData.remainingMacPerUserDay === 0) {
                        return "The maximum number of reservations for MAC pool " + this.macPool.name
                            + " has been exceeded.";
                    } else {
                        return "Request failed. Please contact the technical support."
                    }
                }
            },

            additionalMessage: {
                get() {
                    if (this.responseStatus === 409) {
                        return "Another reservation was processed at the same moment that blocked the process. \n" +
                            "Please reload the data and try again to make a reservation."
                    } else if (this.responseData === null || this.responseData === "") {
                        return "Please note that the maximum number of macs to be reserved per request for MAC pool " + this.macPool.name +
                            " is " + this.macPool.macsPerReq + ".";
                    } else if (this.responseData && this.responseData.remainingMacPerUserDay) {
                        return "There are still " + this.responseData.remainingMacPerUserDay + " MACs available for you today.";
                    } else if (this.responseData && this.responseData.remainingMacPerUserDay === 0) {
                        return "There are no more MACs available for you today.";
                    } else {
                        return "";
                    }
                }
            }
        },

        methods: {
            close() {
                EventBus.$emit('macReservationClosed');
                EventBus.$emit('reservationFailedDialogClosed');
                this.onShow = false;
                this.$emit('close');
            },
        }
    }
</script>

<style>
    .reservation-failed {
        color: red;
        font-weight: bold;
    }

</style>


// WEBPACK FOOTER //
// src/components/macpools/modals/MacPoolReservationFailedModal.vue